import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 图标库
import 'font-awesome/css/font-awesome.min.css'
// 引入全局样式
import './assets/css/index.css'

import axios from 'axios'
import VueParticles from 'vue-particles'
import 'jquery'
import VueResource from 'vue-resource'
import VueAxios from 'vue-axios'
import i18n from './language/i18n'
import store from './store'
import Cookies from "js-cookie"

import App from './App'
import router from './router'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 通过插件的形式挂载
Vue.use(VueParticles)
ElementUI.TableColumn.props.resizable=false
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(VueResource)
Vue.use(VueAxios, axios)
import moment from 'moment'
Vue.prototype.$moment = moment; // 日期格式化

// axios配置
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8'
// 为get和post方法分别添加头信息
axios.defaults.headers.get['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.withCredentials = true
// 需要访问的api的ip地址
axios.defaults.baseURL = 'https://admin.tqscloud.com:8083'
// axios.defaults.baseURL = 'http://localhost:8083'
// axios.defaults.baseURL = 'http://tqsadmin.e-glad.com.cn:7083'
// axios.defaults.baseURL = 'http://221.215.89.43:7083'

/**
 * 设置请求时的拦截器，即在请求前在Authorization字段中写入token
*/
axios.interceptors.request.use(
  config => {
    if (Cookies.get('access_token')) {
      // 把令牌放入到请求头，每次访问后台都会用令牌去做对比，如果不对，是获取不到数据的
      config.headers.Authorization = `Bearer ${Cookies.get('access_token')}`
    }
    if (localStorage.getItem('locale')) {
      config.headers.locale = localStorage.getItem('locale')
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

/**
 * 设置响应时的拦截器，如果http状态码是401或者404则说明请求异常，清空token并返回到登录页面
 */
axios.interceptors.response.use(
  response => {

    // 如果正常调用，返回值为200,并且没有过期，则重新设置token的失效时间
    if (response.status == 200 && Cookies.get('access_token')) {
      Cookies.set('access_token', Cookies.get('access_token'), {
        expires: 1,
      });
    }

    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          Cookies.remove('access_token')
          router.replace({
            name: "login",
            path: '/login',
            query: { redirect: router.currentRoute.fullPath }
          })
          break
        case 404:
          Cookies.remove('access_token')
          router.replace({
            name: "login",
            path: '/login',
            query: { redirect: router.currentRoute.fullPath }
          })
          break
      }
    }
    return Promise.reject(error.response)
  }
)

if (process.env.NODE_ENV === 'development') {
  // require('./mock')
}

/**
 * 路由钩子
 * 未登录的情况，跳转登录界面，登录完成自动跳转原访问页面
 */
// router.beforeEach((to, from, next) => {
//   // let userName = sessionStorage.getItem('user')
//   let userName = localStorage.getItem('user')
//   // 判断路由中的登录验证是否开启
//   if (to.matched.some(route => route.meta && route.meta.requiresAuth)) {
//     let access_token = Cookies.get('access_token')
//     if (!access_token) {
//       // 没有登录信息跳转到登录页
//       next({
//         // 必须加name，不然this.$route获取不到信息
//         name: "login",
//         path: "/login",
//         query: { redirect: to.fullPath }  // 'to.fullPath'跳转到登录之前页面的路径
//       });
//     } else {
//       // 有登录信息，直接跳过
//       if (to.path !== '/login') {
//         // 加载动态菜单和路由
//         // addDynamicMenuAndRoutes(userName, to, from)
//       }
//       next();
//     }
//   } else {
//     next();
//   }
// });


new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  store,
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js